import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ViewRequest } from '../shared/view-request.model';
import { ReportsService } from '../shared/reports.service';

@Component({
  selector: 'app-state-requests',
  templateUrl: './state-requests.component.html',
  styleUrls: ['./state-requests.component.scss']
})
export class StateRequestsComponent implements OnInit, OnChanges {
  displayedColumns: string[] = ['fecha', 'codMateriaSolic', 'nomMateriaSolic', 'codProgramaSolic',
                    'nomProgramaSolic',  'institucion', 'nomInstitucion', 'estado'];
  dataSource: MatTableDataSource<ViewRequest>;
  messageError: String = '';
  claseMessage: String = 'messaje-error';

  @Input() requests: ViewRequest[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private reporstService: ReportsService) {
    this.setTable();
  }

  ngOnInit() {
    this.setTable();
  }

  private setTable() {
    this.dataSource = new MatTableDataSource(this.requests);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnChanges() {
    this.setTable();
  }

}
